const UTM_STORAGE_KEY = "persisted_utm_params"

const UTM_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "utm_platform",
]

const isBrowser = () => typeof window !== "undefined"

/**
 * Extract UTM parameters from a location object's search params.
 * @param {Location} location - The location object from @reach/router or window.location
 * @returns {Object} Object containing supported UTM parameters
 */
export const getUtmParams = location => {
  const search = location?.search || ""
  const searchParams = new URLSearchParams(search)

  return UTM_PARAM_KEYS.reduce((acc, key) => {
    acc[key] = searchParams.get(key) || ""
    return acc
  }, {})
}

/**
 * Filter out empty UTM parameters.
 * @param {Object} utmParams - Object with UTM parameters
 * @returns {Object} Object with only non-empty UTM parameters
 */
export const filterEmptyUtmParams = utmParams => {
  return Object.entries(utmParams || {}).reduce((acc, [key, value]) => {
    if (typeof value === "string" && value.trim() !== "") {
      acc[key] = value.trim()
    }

    return acc
  }, {})
}

export const getStoredUtmParams = () => {
  if (!isBrowser()) {
    return {}
  }

  try {
    const storedValue = window.sessionStorage.getItem(UTM_STORAGE_KEY)

    if (!storedValue) {
      return {}
    }

    return filterEmptyUtmParams(JSON.parse(storedValue))
  } catch (error) {
    return {}
  }
}

export const persistUtmParams = location => {
  const utmParams = filterEmptyUtmParams(getUtmParams(location))

  if (!isBrowser() || Object.keys(utmParams).length === 0) {
    return utmParams
  }

  window.sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParams))

  return utmParams
}

export const getPersistentUtmParams = location => {
  const currentUtmParams = filterEmptyUtmParams(getUtmParams(location))

  if (Object.keys(currentUtmParams).length > 0) {
    return persistUtmParams(location)
  }

  return getStoredUtmParams()
}